<template>
  <div >
    <vs-row vs-w="12" v-for="(item, index) in value" :key="index">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <v-select
          v-model="item.clientId"
          class="w-full"
          label="ClientName"
          :placeholder="$t('client') | capitalize"
          :options="clients"
          :reduce="(option) => option.ClientId"
          :clearable="false"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <v-swatches
          v-model="item.color"
          show-fallback
          fallback-input-type="color"
          swatch-size="24"
          class="mt-1 mx-2"
          :trigger-style="{ width: '60px', height: '34px' }"
        >
        </v-swatches>
        <vs-button
          color="danger"
          type="filled"
          icon-pack="feather"
          icon="icon-minus"
          size="small"
          
          @click="remove(index)"
        ></vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import vSelect from 'vue-select'
export default {
  components: {
    VSwatches,
    'v-select': vSelect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    clients: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    remove(index) {
      this.$emit('remove', index)
    },
  },
}
</script>

<style>
</style>